import { pending, rejected, fulfilled } from './async';
import { replace } from 'react-router-redux';
import * as Auth from 'app/api/auth';

export function login(email, password) {
    return dispatch => {
        dispatch(pending('LOGIN'));
        Auth.login(email, password)
            .then(payload => {
                dispatch(fulfilled('LOGIN', payload));
                dispatch(replace('/'));
            })
            .catch(err => {
                dispatch(rejected('LOGIN', err));
            });
    };
}

export function loginWithToken(token) {
    return dispatch => {
        dispatch(pending('LOGIN_TOKEN'));
        Auth.loginWithToken(token)
            .then(payload => {
                dispatch(fulfilled('LOGIN_TOKEN', payload));
            })
            .catch(err => {
                dispatch(rejected('LOGIN', err));
            });
    };
}

export function clearAndRedirect(dispatch) {
    dispatch(fulfilled('LOGOUT'));
    dispatch({ type: 'RESET' });
}

export function logout() {
    return dispatch => {
        dispatch(fulfilled('LOGOUT'));
        dispatch(replace('/login'));

    };
}
